import React from 'react'
import { connect } from "react-redux";
import {Loader} from '@vds/loaders'
function LoaderSpinner()
{
    return(
        <Loader 
        active={true}
        fullscreen={false}
        surface="light" 
        />
    )
}

export default LoaderSpinner;